import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/src/theme/appclassic';
import { ResetCSS } from 'common/src/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from '../containers/AppClassic/Navbar';
import Banner from '../containers/AppClassic/Banner';
import FeatureSection from '../containers/AppClassic/FeatureSection';
import Company from '../containers/AppClassic/Company';
import Tech from '../containers/AppClassic/Tech';
import Faq from '../containers/AppClassic/Faq';
import Footer from '../containers/AppClassic/Footer';
import GlobalStyle, {
  AppWrapper,
  ContentWrapper
} from '../containers/AppClassic/appClassic.style';
import TeamSection from '../containers/AppClassic/TeamSection';

import SEO from '../components/seo';

export default function() {
  return (
    <ThemeProvider theme={theme}>
      <>
        <SEO
          title="BlueReaction | Your React.js Experts"
          description={''}
          meta={''}
          keywords={['react', 'agency', 'developers', 'expert']}
        />
        <ResetCSS />
        <GlobalStyle />

        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar />
          </Sticky>
          <ContentWrapper>
            <Banner />
            <FeatureSection />
            <Company />
            <Tech />
            <TeamSection />
            {/* <Faq /> */}
          </ContentWrapper>
          <Footer />
        </AppWrapper>
      </>
    </ThemeProvider>
  );
}
